import { FileUploadWithDisplay, IFileUploadWithDisplayProps } from '@file/FileUploadWithDisplay';
import { IProjectFileBase } from '@file/projectFile/projectFile.models';
import { UseQueryResult } from '@tanstack/react-query';
import * as React from 'react';

interface IAttachmentsProps<T> extends Omit<IFileUploadWithDisplayProps, 'defaultFiles' | 'type'> {
  headerComponent?: React.ReactNode;
  useFetchFiles: (props: T, enable?: boolean) => UseQueryResult<IProjectFileBase[] | undefined, unknown>;
  useFetchFilesProps: T;
  setFileCount?: (count: number) => void;
}
export const Attachments: <T>(props: IAttachmentsProps<T>) => React.ReactElement = ({
  headerComponent,
  useFetchFiles,
  useFetchFilesProps,
  setFileCount,
  ...rest
}) => {
  const [isAnyRowUploading, setIsAnyRowUploading] = React.useState<boolean>(false);

  const { data } = useFetchFiles(useFetchFilesProps, !isAnyRowUploading);
  React.useEffect(() => {
    if (!setFileCount) return;
    setFileCount(data?.length || 0);
  }, [data?.length]);
  return (
    <>
      {headerComponent}
      <FileUploadWithDisplay
        type="supplementaryFile"
        {...rest}
        defaultFiles={data ?? []}
        setIsAnyRowUploading={setIsAnyRowUploading}
        isAnyRowUploading={isAnyRowUploading}
      />
    </>
  );
};
